import { ListPromotion } from '~/features/Promotion/ListPromotion/ListPromotion'
import { Container } from '~/shared/ui/Layout'

export const ListPromotionPage = () => {
  return (
    <Container>
      <ListPromotion />
    </Container>
  )
}
